// extracted by mini-css-extract-plugin
export default {"form-field":"w1_6y5PFZovtnYJPlWCa","label":"eu1WA9sxb9iYbgWJ9PRT","contents-wrapper":"nUt36jW5URg6uDv6MzZQ","align-center":"OEy5sM4eKtccrcl4__8a"};